import React from 'react';

const ProjectImage = () => (
  <>
    {/* noop */}
  </>
);

export default ProjectImage;
